export default __webpack_public_path__ + "static/media/budget-empty.c10a6eb5.svg";